import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

export const MSG_GESTAO_AMEI_INDISPONIVEL =
  'Não foi possível acessar o AMEI no momento. Tente novamente mais tarde.';

interface GestaoAmeiHook {
  gestaoAmeiUrl?: string;
  gestaoAmeiUrlLoading: boolean;
}

export function useGestaoAmeiService(): GestaoAmeiHook {
  const { getEnv } = Sebrae.useEnv();

  const [gestaoAmeiUrl, setGestaoAmeiUrl] = React.useState<string>();
  const [gestaoAmeiUrlLoading, setGestaoAmeiUrlLoading] = React.useState(true);

  React.useEffect(() => {
    let current = true;

    getEnv('gestaoAmeiUrl')
      .then((url) => {
        if (current) {
          setGestaoAmeiUrl((url as string) || undefined);
        }
      })
      .catch(() => {
        if (current) {
          setGestaoAmeiUrl(undefined);
        }
      })
      .finally(() => {
        if (current) {
          setGestaoAmeiUrlLoading(false);
        }
      });

    return () => {
      current = false;
    };
  }, [getEnv]);

  return {
    gestaoAmeiUrl,
    gestaoAmeiUrlLoading,
  };
}
